<div class="header-div d-flex justify-content-between">
  <h6 class="text-uppercase mb-0">{{ (isTemplateEdit ? 'Edit Template' : title) | translate }}</h6>
  @if (!isInitial && entity) {
    <div class="sample-info d-flex">
      @if (entity.sampleNumber) {
        <div class="field">
          <span class="label">{{"Sample Number" | translate}}:</span><span
        class="value">{{entity.sampleNumber | translate}}</span>
      </div>
    }
    <div class="field"><span class="label">{{"Sample Type" | translate}}:</span><span
  class="value">{{sampleTypeEnum[entity.sampleType] | translate}}</span></div>
  <div class="field"><span class="label">{{"Sample Category" | translate}}:</span><span
class="value">{{sampleCategoryEnum[entity.sampleCategory] | translate}}</span>
</div>
<div class="field"><span class="label">{{"Organization Level" | translate}}:</span><span
class="value">{{entity.organizationLevelName}}</span></div>
<mat-form-field appearance="fill" class="status-select">
  <mat-select [(value)]="entity.sampleStatus" panelClass="status-dropdown-panel">
    <mat-select-trigger>
      <span class="status-badge"
        [ngClass]="statusBadgeClassById.get(entity.sampleStatus)">
        {{ sampleStatusName | translate }}
      </span>
    </mat-select-trigger>
    @for (status of sampleStatusList; track trackById($index, status)) {
      <mat-option class="status-dropdown-options" [value]="status.id">
        <span class="status-badge" [ngClass]="statusBadgeClassById.get(status.id)">
          {{status.name | translate}}
        </span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
</div>
}
</div>

@if (isFormLoading) {
  <app-rings-loader></app-rings-loader>
}

@if (!isInitial && stepperConfig) {
  <div class="stepper-wrapper">
    <div class="stepper-template-actions">
      @if (availableTemplates.length > 0 && !isTemplateEdit) {
        <mat-form-field appearance="outline" class="stepper-template-select">
          <mat-label>{{ 'Template' | translate }}</mat-label>
          <mat-select [value]="selectedTemplateId" (valueChange)="onTemplateSelected($event)">
            <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
            @for (tpl of availableTemplates; track trackById($index, tpl)) {
              <mat-option [value]="tpl.id">
                {{ tpl.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isAdd && !isTemplateEdit) {
        <button type="button" class="save-modal-btn save-as-template-btn" [disabled]="isSavingTemplate" (click)="onSaveTemplateClick()">
          <i class="material-icons">bookmark_add</i>
          {{ saveTemplateLabel | translate }}
        </button>
      }
    </div>
    <app-stepper-container [config]="stepperConfig" (stepChanged)="onStepChanged($event)">
    </app-stepper-container>
  </div>
}

@if (isInitial && !isFormLoading) {
  <div class="initial-sample-form">
    <div class="form-fields-body px-3">
      @if (isAdd && entity.sampleType == null && allTemplates.length > 0) {
        <div class="template-selector template-selector--upfront px-0 mb-2">
          <mat-form-field appearance="outline" class="template-selector__field">
            <mat-label>{{ 'Apply Template' | translate }}</mat-label>
            <mat-select [value]="selectedTemplateId" (valueChange)="onTemplateSelectedUpFront($event)">
              <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
              @for (tpl of allTemplates; track trackById($index, tpl)) {
                <mat-option [value]="tpl.id">
                  {{ tpl.name }}
                  <span class="sample-type-tag">{{ tpl.sampleTypeName | translate }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="row">
        <!-- Fields are tracked by position: two fields bind agentIds and label fields have no property, so the property is not a unique key. -->
        @for (field of initialFields; track $index) {
          <app-dynamic-form-field [field]="field" [entity]="entity" [templateState]="templateFieldStates.get(field.property)" (valueChanged)="onTemplateFieldEdited(field); updateFieldVisibility()"></app-dynamic-form-field>
        }
      </div>
      @if (isDefaultTemplateBannerVisible && defaultTemplateName) {
        <div class="template-default-banner">
          <span class="template-default-banner__text">
            <i class="material-icons">star</i>
            {{ 'Default template applied' | translate }}: <strong>{{ defaultTemplateName }}</strong>
          </span>
          <button type="button" class="template-default-banner__clear" (click)="clearTemplateFields()">
            {{ 'Clear' | translate }}
          </button>
        </div>
      }
      @if (availableTemplates.length > 0 && !isDefaultTemplateBannerVisible) {
        <div class="template-selector px-0 mt-2">
          <mat-form-field appearance="outline" class="template-selector__field">
            <mat-label>{{ 'Apply Template' | translate }}</mat-label>
            <mat-select [value]="selectedTemplateId" (valueChange)="onTemplateSelected($event)">
              <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
              @for (tpl of availableTemplates; track trackById($index, tpl)) {
                <mat-option [value]="tpl.id">
                  {{ tpl.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="bottom-btns">
      <div class="left-btns d-flex">
        <button class="custom-main-btn px-5" (click)="close(true)"> {{"Cancel" | translate}} </button>
        <button class="px-5 custom-main-btn" (click)="showStepper()"
          [disabled]="entity.sampleCategory == null || entity.sampleType == null || entity.organizationLevelId == null">
          {{"Next" |translate}}
        </button>
      </div>
    </div>
  </div>
}

<ng-template #stepTpl>
  <div class="form-fields-body">
    <div class="row">
      @if (currentStep.id === 'weatherInfo' && canFetchWeather) {
        <div class="col-12 weather-fetch">
          <button type="button" class="custom-main-btn weather-fetch__button" [disabled]="isWeatherFetchDisabled" (click)="fetchWeather()">
            <i class="material-icons">cloud_download</i>
            {{ 'Fetch Weather Data' | translate }}
          </button>
          @if (weatherFetchStatus === weatherFetchStatusEnum.Loading) {
            <span class="weather-fetch__status">
              <mat-spinner diameter="16"></mat-spinner>
              {{ 'Fetching weather data...' | translate }}
            </span>
          } @else if (weatherMessage) {
            <span class="weather-fetch__status"
              [class.weather-fetch__status--applied]="weatherFetchStatus === weatherFetchStatusEnum.Applied"
              [class.weather-fetch__status--error]="weatherFetchStatus === weatherFetchStatusEnum.Error">
              {{ weatherMessage }}
            </span>
          } @else {
            <span class="weather-fetch__hint" [class.weather-fetch__hint--unavailable]="isWeatherLookupUnavailable">{{ weatherHint }}</span>
          }
        </div>
      }
      <!-- Fields are tracked by position: two fields bind agentIds and label fields have no property, so the property is not a unique key. -->
      @for (field of currentStep?.fields; track $index) {
        <app-dynamic-form-field [field]="field" [entity]="entity" [templateState]="templateFieldStates.get(field.property)" (valueChanged)="onTemplateFieldEdited(field); updateFieldVisibility()"></app-dynamic-form-field>
      }
      @if (currentStep.id == 'employee') {
        @for (field of employeeFields; track $index) {
          <app-dynamic-form-field [field]="field" [entity]="entity" [templateState]="templateFieldStates.get(field.property)" (valueChanged)="onTemplateFieldEdited(field); updateFieldVisibility()"></app-dynamic-form-field>
        }
      }
      @if (currentStep.id === 'controlFields') {
        <div class="col-12 mt-3">
          <ng-container *ngTemplateOutlet="tasksTableTemplate"></ng-container>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #tasksTableTemplate>
  <div class="custom-theme-table px-3">
    <div class="custom-scrollbar table-responsive outer-bordered-table">

      <table mat-table [dataSource]="entity.sampleTasks" class="table table-striped">

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center" colspan="4">
            {{ 'No tasks added' | translate }}
          </td>
        </tr>

        <ng-container matColumnDef="taskId">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Task' | translate }}
          </th>

          <td mat-cell *matCellDef="let element; let i = index">

            <mat-form-field appearance="fill" class="w-100">
              <mat-select [(ngModel)]="element.taskId" (selectionChange)="onTaskSelected($event.value, element)" class="w-100">
                <mat-option>
                  <ngx-mat-select-search [(ngModel)]="taskSearch[i]" (ngModelChange)="filterTasks($event, i)"
                    [placeholderLabel]="'Search' | translate">
                  </ngx-mat-select-search>
                </mat-option>

                @for (group of (filteredTasks[i] || tasks); track trackByIndex($index)) {
                  <mat-optgroup [label]="group.groupName">
                    @for (item of group.items; track trackById($index, item)) {
                      <mat-option [value]="item.id" [disabled]="isTaskSelected(item.id, element)">
                        {{ item.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }

                <button type="button" (click)="openTaskDialog(element); $event.stopPropagation()" class="add-task-btn">
                  <span class="text-primary">{{ 'Add New Task' | translate }}</span>
                </button>

              </mat-select>
            </mat-form-field>

          </td>
        </ng-container>

        <ng-container matColumnDef="approximateTimeMinutes">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Approximate Runtime (Minutes)' | translate }}
          </th>

          <td mat-cell *matCellDef="let element">
            <input type="number"
              class="form-control"
              min="0"
              step="1"
              [(ngModel)]="element.approximateTimeMinutes" />
            </td>
          </ng-container>

          <ng-container matColumnDef="applicablePpeWorn">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Appropriate PPE Worn' | translate }}
            </th>

            <td mat-cell *matCellDef="let element" class="text-center">
              <mat-slide-toggle
                [(ngModel)]="element.applicablePpeWorn">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>

            <td mat-cell *matCellDef="let element; let i = index">
              <span class="material-icons cursor-pointer"
                (click)="removeTaskRow(i)">
                delete
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>

      <div class="mt-3">
        <button type="button"
          class="custom-main-btn"
          (click)="addTaskRow()">
          + {{ 'Add Task' | translate }}
        </button>
      </div>

    </div>
  </ng-template>